import {
  GET_JOB_REPORT_REQUEST,
  GET_JOB_REPORT_SUCCESS,
  GET_JOB_REPORT_FAILURE,
} from "../../actionTypes";

export const getJobReportRequest = (data) => ({
  type: GET_JOB_REPORT_REQUEST,
  payload: data,
});

export const getJobReportSuccess = (data) => ({
  type: GET_JOB_REPORT_SUCCESS,
  payload: data,
});

export const getJobReportFailure = (error) => ({
  type: GET_JOB_REPORT_FAILURE,
  payload: error,
});


